export default {
  SET_OFFER_MEAL: 'SET_OFFER_MEAL',
  SET_SOLD_OUT: 'SET_SOLD_OUT',
  SET_UPDATED_OFFER_MEAL_ID: 'SET_UPDATED_OFFER_MEAL_ID',
  SET_VISIBLE: 'SET_VISIBLE',
  SET_PRICE_FORMATTED: 'SET_PRICE_FORMATTED',
  SET_VALID: 'SET_VALID',
  SET_ERRORS: 'SET_ERRORS',
  SET_PACKAGING_PRICE_FORMATTED: 'SET_PACKAGING_PRICE_FORMATTED',
}
